<template>
  <div>
    <PageAllow controller="Waves" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('StockOrderOUT.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('Waves', 'batchPickingPrint')"
              small
              color="print"
              dark
              class="ms-1"
              @click="doPrint()"
            >
              <v-icon x-small class="pe-1">fa-print</v-icon>
              {{ $t("Wave.batchPickingPrint") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="keyword"
                  v-model="options.wave_code"
                  @text="waveCodeKeyword = $event"
                  :label="$t('Wave.Fields.wave_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stocksSelected"
                  unclearable
                  :wmsSetting="[1]"
                  :stockTypes="[0]"
                />
              </v-col>
              <v-col
                v-if="settings && settings.stock_area_enable"
                cols="12"
                sm="6"
                md="4"
              >
                <SearcherStockArea
                  v-model="stockAreasSelected"
                  :stockId="stockId"
                  :disabled="!stockAreaSetting"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherWaveStatus v-model="options.status" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="waves"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.distribution_user_name="{ item }">
            <span :title="item.distribution_user_name" style="cursor: pointer">
              {{
                item.distribution_user_name &&
                item.distribution_user_name.length > 10
                  ? item.distribution_user_name.slice(0, 10) + "......"
                  : item.distribution_user_name
              }}
            </span>
          </template>
          <template v-slot:item.wave_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.wave_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop_name_arr="{ item }">
            <span v-if="item.shop_name_arr.length == 1">
              <a
                class="text-no-wrap font-weight-bold"
                @click.stop="
                  currentItem = item;
                  shopDialog = true;
                "
              >
                {{ item.shop_name_arr[0] }}
              </a>
            </span>
            <span v-else-if="item.shop_name_arr.length > 1">
              <a
                class="text-no-wrap font-weight-bold"
                @click.stop="
                  currentItem = item;
                  shopDialog = true;
                "
              >
                {{ $t("Wave.Fields.shop_counts", [item.shop_name_arr.length]) }}
              </a>
            </span>
            <span v-else>
              {{ item.shop_name_arr.length }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | waveStatusColor"
              :text-color="item.status | waveStatusTextColor"
            >
              {{ item.status | waveStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.stock_area_name="{ item }">
            {{ item.stock_area ? item.stock_area_name : "" }}
          </template>
          <template v-slot:item.receive_time="{ item }">
            {{ item.receive_time | formatTime }}
          </template>

          <template v-slot:item.actions="{ item }">
            <WaveActions
              :wave="item"
              showView
              :showReceive="item.actions.receive"
              :showRelease="item.actions.wave_release"
              :showStockPicking="item.actions.stock_picking"
              :showStockSorting="item.actions.stock_order_binding"
              :showForceCompleteSorting="item.actions.force_complete_sorting"
              @save="getWavesFromAPI()"
              @release="
                releaseDialog = true;
                releaseWaveId = $event;
              "
              @forceComplete="
                forceCompleteSortingDialog = true;
                forceCompleteWaveId = $event;
              "
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <DialogAlert
      v-model="releaseDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Wave.Messages.release_wave_confirm')"
      useConfirm
      @confirm="releaseWave()"
    />
    <DialogAlert
      v-model="forceCompleteSortingDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('Wave.Messages.force_complete_sorting_confirm')"
      useConfirm
      @confirm="forceCompleteSorting()"
    />
    <StockOrderShopDialog v-model="shopDialog" :items="currentItem" />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherWaveStatus from "@/components/plugins/SearcherWaveStatus";
import Waves from "@/api/waves";
import WaveActions from "./plugins/Actions";
import DialogAlert from "@/components/plugins/DialogAlert";
import StockOrderShopDialog from "./plugins/StockOrderShopDialog";

const defaultOptions = {
  date_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  date_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  wave_code: "",
  stock_id: 0,
  stock_area_id: null,
  status: [1, 2, 3],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStock,
    SearcherStockArea,
    SearcherWaveStatus,
    WaveActions,
    DialogAlert,
    StockOrderShopDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        replace: true,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.waves"),
        disabled: true,
        href: "/waves",
      },
    ],
    headers() {
      return [
        {
          text:
            i18n.t("Wave.Fields.wave_code") +
            " / " +
            i18n.t("Wave.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "wave_code",
        },
        {
          text: i18n.t("Wave.Fields.distribution_user_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "distribution_user_name",
          width: 200,
        },
        {
          text: i18n.t("Wave.Fields.shops"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_name_arr",
        },
        {
          text: i18n.t("Wave.Fields.wave_ruler"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "wave_ruler.name",
        },
        {
          text: i18n.t("Wave.Fields.stock_order_num"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "stock_order_num",
        },
        {
          text: i18n.t("Wave.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("Wave.Fields.stock_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "stock_name",
        },
        {
          text: i18n.t("Wave.Fields.stock_area_name"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "stock_area_name",
        },
        {
          text: i18n.t("Wave.Fields.receive_user"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "name",
        },
        {
          text: i18n.t("Wave.Fields.receive_time"),
          align: "start",
          sortable: false,
          value: "receive_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    waves: [],
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    waveCodeKeyword: "",
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("waves-options")
        ? sessionStorage.getItem("waves-options")
        : JSON.stringify(defaultOptions)
    ),
    stocksSelected: null,
    stockAreasSelected: null,
    stockId: 0,
    stockAreaSetting: false,
    detailMode: false,
    printBtnMenu: false,
    exportBtnMenu: false,
    releaseDialog: false,
    releaseWaveId: 0,
    forceCompleteSortingDialog: false,
    forceCompleteWaveId: 0,
    currentItem: null,
    shopDialog: false,
  }),

  mounted() {
    this.$commonUtils.loadOptions("waves", ["stocksSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
          if (
            typeof this.options.date_from != "undefined" &&
            typeof this.options.date_to != "undefined"
          )
            this.datetimeRage = [this.options.date_from, this.options.date_to];
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "stocksSelected":
              this.stocksSelected = this.$route.params.stock_id
                ? { id: this.$route.params.stock_id }
                : selected.value;
              break;
            case "stockAreasSelected":
              this.stockAreasSelected = this.$route.params.stock_area_id
                ? { id: this.$route.params.stock_area_id }
                : selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  methods: {
    resetSearch() {
      this.stocksSelected = null;
      this.stockAreasSelected = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },

    onSearch() {
      this.options = Object.assign({}, this.options, {
        wave_code: this.waveCodeKeyword,
      });
    },

    getWavesFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Waves.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.waves = response.data.waves;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },

    releaseWave() {
      Waves.release({ wave_id: this.releaseWaveId }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getWavesFromAPI();
          }
        }.bind(this)
      );
    },

    forceCompleteSorting() {
      Waves.forceCompleteSorting({ wave_id: this.forceCompleteWaveId }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getWavesFromAPI();
            //小提示窗
            this.$snackbar.success(
              i18n.t("Wave.Messages.force_complete_sorting_success")
            );
          }
        }.bind(this)
      );
    },
    doPrint() {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = JSON.parse(JSON.stringify(this.options));
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          var path = null;
          path = "/print/wave-stockPicking-batch-print";
          if (path) this.$router.push({ path: path, query: options });
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getWavesFromAPI();
        sessionStorage.setItem("waves-options", JSON.stringify(this.options));
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.date_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.date_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.date_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.date_to = this.datetimeRage[1];
        }
      },
    },
    stocksSelected: {
      handler() {
        if (this.stocksSelected) {
          this.options.stock_id = this.stocksSelected.id;
          this.stockId = this.stocksSelected.id;
          if (this.stocksSelected.stock_area) {
            this.stockAreaSetting = true;
          } else {
            this.stockAreaSetting = false;
          }
        } else {
          this.options.stock_id = 0;
          this.stockId = 0;
        }
        sessionStorage.setItem(
          "waves-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    stockAreasSelected: {
      handler() {
        this.options.stock_area_id = this.stockAreasSelected
          ? this.stockAreasSelected.id
          : 0;
        sessionStorage.setItem(
          "waves-stockAreasSelected",
          JSON.stringify(this.stockAreasSelected)
        );
      },
    },
  },
};
</script>
